<div
        fileDrop
        [accept]="supportedExtensions"
        (fileOver)="onFileOver($event)"
        (fileDrop)="onFileChange($event)"
        [ngClass]="cssClass"
        [ngClass]="{'img-ul-file-is-over': fileOver}"
        [ngStyle]="style?.layout"
>
    <div *ngIf="!preview || files.length === 0" class="img-ul-file-upload img-ul-hr-inline-group">
        <div class="img-ul-drag-box-msg">Drag and drop your images here or <label for="fileInput"><a href id="fileInputButton" onclick="document.getElementById('fileInput').click(); return false">Browse images</a></label></div>
    </div>

    <input id="fileInput"
            type="file"
            [accept]="supportedExtensions"
            (change)="onFileChange(input.files)"
            #input>

    <p class="img-ul-file-too-large" *ngIf="showFileTooLargeMessage" [innerText]="fileTooLargeMessage"></p>

    <div *ngIf="preview" class="img-ul-container img-ul-hr-inline-group" [ngStyle]="style?.previewPanel">
        <div
                class="img-ul-image"
                *ngFor="let file of files"
                [ngStyle]="{'background-image': 'url('+ file.src +')'}"
        >
            <div *ngIf="file.pending" class="img-ul-loading-overlay">
                <div class="img-ul-spinning-circle"></div>
            </div>
            <div *ngIf="!file.pending" class="img-ul-x-mark" (click)="deleteFile(file)">
                <span class="img-ul-close"></span>
            </div>
        </div>
    </div>
</div>